export default __webpack_public_path__ + "409560c05417bc5950d6d65c79233d3c.svg";